import { render, staticRenderFns } from "./clientOrgSummary.vue?vue&type=template&id=1d92a594&scoped=true"
import script from "./clientOrgSummary.vue?vue&type=script&lang=js"
export * from "./clientOrgSummary.vue?vue&type=script&lang=js"
import style0 from "./clientOrgSummary.vue?vue&type=style&index=0&id=1d92a594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d92a594",
  null
  
)

export default component.exports